var React = require('react');

function Land (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#eeeef4","d":"M25.9 22.67L50 36.62 26.82 50 2.72 36.06 25.9 22.67z","key":0}),React.createElement("path",{"fill":"#a4c2ea","d":"M25.96 17.64l20.97 12.13-20.17 11.64L5.79 29.28l20.17-11.64z","key":1}),React.createElement("path",{"fill":"#9bbae7","d":"M10.09 20.45l-7.63 4.41 1.4.8 7.94-4.51-1.71-.7z","key":2}),React.createElement("ellipse",{"cx":"11.02","cy":"20.78","rx":"1.02","ry":".59","fill":"#9bbae7","key":3}),React.createElement("path",{"fill":"#679de8","d":"M10 16.82h2.03v3.96H10z","key":4}),React.createElement("path",{"fill":"#679de8","d":"M11.02 0v18.64l-6.29-3.62L11.02 0z","key":5}),React.createElement("path",{"fill":"#c7d7f0","d":"M11.02 0v18.64l6.28-3.62L11.02 0z","key":6})]);
}

Land.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 50 50"};

module.exports = Land;

Land.default = Land;
